import firebase from "@/firebase";

export default {
  namespaced: true,
  state: {
    notes: [],
  },
  getters: {
    getNotes(state) {
      return state.notes;
    },
  },
  mutations: {
    addNote(state, data) {
      state.notes.push(data);
    },
    removeNote(state, id) {
      const i = state.notes.findIndex((a) => a.id === id);
      state.notes.splice(i, 1);
    },
    setNote(state, data) {
      const i = state.notes.findIndex((a) => a.id === data.id);
      state.notes[i] = data;
    },
    setNotes(state, data) {
      state.notes = data;
    },
  },
  actions: {
    async listNotes(state, id) {
      let notes = [];
      const refs = await firebase.db
        .collection("profiles")
        .doc(id)
        .collection("notes")
        .get();
      refs.forEach((ref) => notes.push(ref.data()));
      state.commit("setNotes", notes);
    },
    async createNote(state,  { data, profile }) {
      const note = await firebase.db
        .collection("profiles")
        .doc(profile)
        .collection("notes")
        .add(data);
      await note.update({ id: note.id });
      state.commit("addNote", data);
    },
    async deleteNote(state,  { profile, note }) {
      await firebase.db
        .collection("profiles")
        .doc(profile)
        .collection("notes")
        .doc(note)
        .delete();
      state.commit("removeNote", note);
    },
    async updateNote(state, { data, profile, note }) {
      await firebase.db
        .collection("profiles")
        .doc(profile)
        .collection("notes")
        .doc(note)
        .update(data);
      state.commit("setNote", data);
    },
  },
};
